<template>
<v-layout align-center justify-center align-content-center >
    
<AgencySelection />

    
</v-layout>
</template>
<script>
import AgencySelection from '@/components/agency-selection.vue';

export default {
    components: {
        AgencySelection
    }
}
</script>
<style scoped>
</style>